import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Page, Block, BlockTitle } from "framework7-react";
import AppNavbar from "modules/1_layout/mobile/AppNavbar";
import { getCustomFormsMenu, getCustomFormsMenus } from "../actions";

const mapStateToProps = (state, ownProps) => {
  const menu_id = ownProps.f7route?.params?.menu_id;

  return {
    menu_id,
    custom_forms_menu: state.custom_forms_menus[menu_id],
  };
};

const CustomFormsMenusModulePage = (props) => {
  const { menu_id, custom_forms_menu } = props;

  useEffect(() => {
    props.getCustomFormsMenus();
    if (menu_id) props.getCustomFormsMenu(menu_id);
  }, [menu_id]);

  const menuLabel = custom_forms_menu?.label || "Menu";

  return (
    <Page>
      <AppNavbar title={menuLabel} />
      <BlockTitle>{menuLabel}</BlockTitle>
      <Block>
        {custom_forms_menu?.module_screen_text ? (
          <p style={{ whiteSpace: "pre-wrap" }}>{custom_forms_menu.module_screen_text}</p>
        ) : (
          <p className="text-color-gray">Use the menu panel to open custom forms and sub menus.</p>
        )}
      </Block>
    </Page>
  );
};

export default connect(mapStateToProps, { getCustomFormsMenu, getCustomFormsMenus })(CustomFormsMenusModulePage);
